import React, { Fragment } from 'react';
import { useQuery } from "react-query";
import { Link } from 'react-router-dom';

import { ButtonsRow, Column, ColumnContainer, Divider, MainButton, SectionTitle, TileSlider, TitleContainer } from "@beacharound/beacharound-ui";

import { getProducts } from '../../api/products';
import { getBundleTitle } from '../../helpers/products';

export default function BeachesRentalsSlider({ match }) {

    const { beachSlug } = match.params;

    const params = {
        activitySlug: beachSlug,
        limit: 5,
        params: {
            bundleType: { $exists: false },
            type: "rental",
        }
    };

    const { data: products } = useQuery(['products', beachSlug, 'rental', params], () =>
        getProducts(params), {
        enabled: !!beachSlug,
        refetchOnWindowFocus: false
    }
    );

    if (!products || products.length <= 0 || !Array.isArray(products)) {
        return <Fragment></Fragment>
    }

    return (
        <ColumnContainer noMargin>
            <Column>
                <TitleContainer>
                    <SectionTitle text="Le esperienze proposte da questa spiaggia" />
                </TitleContainer>
                <ColumnContainer noMargin>
                    <Column>
                        <TileSlider slides={products.sort((a, b) => a.price - b.price).map(product => {
                            // let string = "A partire da";

                            const { title, subtitle } = getBundleTitle(product, { main: true });
                            // const price = product.price?.toFixed(2)
                            const priceComparison = product.priceComparison && product.priceComparison?.toFixed(2);
                            // string = `${string} ${priceComparison ? `<strike>${priceComparison} €</strike> ` : ""}${price}€`
                            return {
                                title,
                                text: subtitle,
                                pretitle: product.price > 0 ? undefined : "Esperienza gratuita!",
                                highlight: priceComparison ? "In sconto!" : ""
                            }
                        })} />
                    </Column>
                </ColumnContainer>
                <ButtonsRow fill marginBottom>
                    <MainButton
                        border
                        text="Scopri tutte le esperienze"
                        component={Link}
                        to={`/prenotazione-servizi/${beachSlug}`}
                    />
                </ButtonsRow>
                <Divider />
            </Column>
        </ColumnContainer>
    );
}